export default function UserAgreement() {
  return (
    <div className="prose prose-sm max-w-none">
      <h1 className="text-2xl font-bold mb-6 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
        Пользовательское соглашение
      </h1>

      <p className="text-gray-600 mb-4">
        Дата последнего обновления: 21 апреля 2026 года
      </p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          1. Общие положения
        </h2>
        <p className="text-gray-700 mb-2">
          Настоящее Пользовательское соглашение (далее — «Соглашение»)
          регулирует отношения между администрацией сервиса генерации песен
          (далее — «Администрация») и пользователем сервиса (далее —
          «Пользователь»).
        </p>
        <p className="text-gray-700">
          Начиная использовать Сервис, Пользователь считается принявшим условия
          настоящего Соглашения в полном объеме без каких-либо оговорок и
          исключений.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          2. Предмет соглашения
        </h2>
        <p className="text-gray-700">
          Администрация предоставляет Пользователю доступ к Сервису для
          генерации музыкальных композиций с использованием технологий
          искусственного интеллекта на условиях, определенных настоящим
          Соглашением.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          3. Права и обязанности пользователя
        </h2>

        <h3 className="text-lg font-semibold text-gray-900 mb-2 mt-4">
          3.1. Пользователь имеет право:
        </h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>Использовать Сервис для создания музыкальных композиций</li>
          <li>Загружать собственные тексты для генерации песен</li>
          <li>Скачивать сгенерированные композиции после оплаты</li>
          <li>
            Обращаться в службу поддержки по вопросам использования Сервиса
          </li>
        </ul>

        <h3 className="text-lg font-semibold text-gray-900 mb-2 mt-4">
          3.2. Пользователь обязуется:
        </h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>Соблюдать условия настоящего Соглашения</li>
          <li>Не использовать Сервис в незаконных целях</li>
          <li>Не загружать контент, нарушающий права третьих лиц</li>
          <li>
            Не использовать Сервис для создания материалов, содержащих призывы к
            насилию, дискриминацию или иной противоправный контент
          </li>
          <li>Не пытаться обойти технические ограничения Сервиса</li>
          <li>
            Не распространять полученные материалы с водяными знаками без оплаты
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          4. Права и обязанности администрации
        </h2>

        <h3 className="text-lg font-semibold text-gray-900 mb-2 mt-4">
          4.1. Администрация имеет право:
        </h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>
            Изменять условия настоящего Соглашения в одностороннем порядке
          </li>
          <li>
            Ограничивать или прекращать доступ Пользователя к Сервису при
            нарушении условий Соглашения
          </li>
          <li>
            Удалять контент, нарушающий законодательство или настоящее
            Соглашение
          </li>
          <li>
            Проводить технические работы с временным ограничением доступа к
            Сервису
          </li>
        </ul>

        <h3 className="text-lg font-semibold text-gray-900 mb-2 mt-4">
          4.2. Администрация обязуется:
        </h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>
            Обеспечивать функционирование Сервиса в соответствии с его описанием
          </li>
          <li>Предоставлять доступ к оплаченным материалам</li>
          <li>
            Защищать персональные данные Пользователей в соответствии с
            Политикой конфиденциальности
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          5. Интеллектуальная собственность
        </h2>
        <p className="text-gray-700 mb-2">
          5.1. Все права на Сервис, включая программное обеспечение, дизайн и
          контент, принадлежат Администрации.
        </p>
        <p className="text-gray-700 mb-2">
          5.2. Пользователь получает неисключительную лицензию на использование
          сгенерированных композиций после полной оплаты.
        </p>
        <p className="text-gray-700">
          5.3. Права на тексты песен, загруженные Пользователем, остаются у
          Пользователя. Администрация использует эти тексты исключительно для
          генерации музыкальных композиций.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          6. Платежи и возвраты
        </h2>
        <p className="text-gray-700 mb-2">
          6.1. Стоимость услуг указана на сайте Сервиса и может быть изменена
          Администрацией в одностороннем порядке.
        </p>
        <p className="text-gray-700 mb-2">
          6.2. Оплата производится через платежные системы-партнеры Сервиса.
        </p>
        <p className="text-gray-700">
          6.3. Возврат средств возможен в случае технической невозможности
          предоставления услуги. Решение о возврате принимается Администрацией в
          течение 5 рабочих дней.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          7. Ограничение ответственности
        </h2>
        <p className="text-gray-700 mb-2">
          7.1. Сервис предоставляется «как есть». Администрация не гарантирует
          бесперебойную работу Сервиса.
        </p>
        <p className="text-gray-700 mb-2">
          7.2. Администрация не несет ответственности за качество
          сгенерированных композиций, которое зависит от используемых алгоритмов
          искусственного интеллекта.
        </p>
        <p className="text-gray-700">
          7.3. Администрация не несет ответственности за действия Пользователя,
          нарушающие права третьих лиц.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          8. Конфиденциальность
        </h2>
        <p className="text-gray-700">
          Вопросы обработки персональных данных регулируются Политикой
          конфиденциальности, являющейся неотъемлемой частью настоящего
          Соглашения.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          9. Срок действия соглашения
        </h2>
        <p className="text-gray-700">
          Настоящее Соглашение вступает в силу с момента начала использования
          Сервиса и действует до момента прекращения использования Сервиса
          Пользователем или блокировки доступа Администрацией.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          10. Разрешение споров
        </h2>
        <p className="text-gray-700">
          Все споры решаются путем переговоров. При невозможности достижения
          согласия споры разрешаются в судебном порядке в соответствии с
          законодательством Российской Федерации.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          11. Контактная информация
        </h2>
        <p className="text-gray-700">
          По вопросам использования Сервиса вы можете связаться с нами по
          электронной почте: support@music-generator.ru
        </p>
      </section>
    </div>
  );
}
